import React from 'react';
import { withRouter } from 'inferno-router';
import { resolveStyle } from './base_components';

import util from '../tools/util';

type Props = {
  style?: any;
  className?: string;
  text?: string;
  href: string;
  history: any;
};

class Link extends React.PureComponent<Props> {
  _onPress = (e) => {
    const { href } = this.props;
    if (href && !href.startsWith('http')) {
      util.stopAll(e);
      this.props.history.push(this.props.href);
      return false;
    }
  };
  render() {
    const { style, className: extraClass, children, text, href } = this.props;

    const { className, inlineStyle } = resolveStyle(style, extraClass);
    return (
      <a
        className={'base-component-text-link ' + className}
        style={inlineStyle}
        href={href}
        onClick={this._onPress}
      >
        {text || children}
      </a>
    );
  }
}

export default withRouter(Link);
